// src/HeroSection.js
import React, { useState, useEffect } from 'react';

const HeroSection = () => {
  const [currentImage, setCurrentImage] = useState(0);

  const images = [
    { url: `${process.env.PUBLIC_URL}/images/hero.svg`, opacity: 1 },
    { url: `${process.env.PUBLIC_URL}/images/hero2.svg`, opacity: 0 },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev === 0 ? 1 : 0));
    }, 5000); // Change image every 5 seconds (5000 ms)

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  return (
    <section
      style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'black',
          opacity: 0.5,
          zIndex: 10,
        }}
      ></div>

      {images.map((image, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${image.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            transition: 'opacity 1s',
            opacity: currentImage === index ? 1 : 0,
            zIndex: 0,
          }}
        ></div>
      ))}

      <div
        style={{
          position: 'relative',
          zIndex: 20,
          padding: '0 1rem',
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(2rem, 5vw, 3.75rem)',
            fontWeight: 'bold',
            marginBottom: '1rem',
          }}
        >
          Learn Igbo with Ease
        </h1>
        <p
          style={{
            fontSize: 'clamp(1rem, 4vw, 1.25rem)',
            marginBottom: '2rem',
          }}
        >
          Join our community and start learning today!
        </p>
        <a
          href="/register"
          style={{
            backgroundColor: '#ff7c0a',
            color: 'white',
            padding: '0.5rem 1rem',
            fontSize: '1rem',
            fontWeight: 'bold',
            borderRadius: '0.5rem',
            transition: 'background-color 0.3s',
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#e66b00')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#ff7c0a')}
        >
          Get Started
        </a>
      </div>
    </section>
  );
};

export default HeroSection;